// deno-fmt-ignore-file
export function FromSymbol(context, type) {
    return Symbol();
}
